<template>
    <div class="timeout-wrapper">
		<div v-if="showWaitingText" class="waiting-text">
			Waiting for opponent
		</div>
        <div
            class="timeout-widget"
            :class="{
                ['timed-out']: timedOut,
                ['alert']: countdownAlert,
                ['clickable']: !activePlayer,
            }"
            @click="openModal()"
        >
            <fa-icon class="timeout-icon" icon="hourglass" />
            <span class="time-remaining" v-if="timeRemaining && !timedOut || timedOut && activePlayer">
                {{timeRemaining}}
            </span>
            <span class="claim-victory" v-if="timeRemaining && timedOut && !activeTeam">
                Claim Victory
            </span>
        </div>
    </div>

</template>

<script>
import moment from 'moment';

const noTimeRemaining = '00:00';

export default {
    props: ['refresh', 'showWaitingText'],
    name: 'Timeout',
    created() {
        this.startCountdown();
    },
    watch: {
        refresh(current, prev) {
            if (current !== prev) {
                this.countdownAlert = false;
                this.refreshTimeout = moment().format();
                this.startCountdown();
            }
        },
        timeRemaining(current, prev) {
            if (current !== prev) {
                this.refreshTimeout = moment().format();
            }
        },
    },
    data() {
        return {
            refreshInterval: null,
            timeRemaining: null,
            refreshTimeout: moment().format(),
            noTimeRemaining,
            countdownAlert: false,
        };
    },
    computed: {
        gameId() {
            return parseInt(this.$route.params.id, 10);
        },
        gameState() {
            return this.$store.state.gameState;
        },
        timeLimit() {
            return this.gameState.timeLimit;
        },
        updatedAt() {
            return this.gameState.updatedAt;
        },
        timedOut() {
            return this.timeRemaining === noTimeRemaining;
        },
        activePlayer() {
            const { activePlayerId } = this.gameState;
            return this.player.id === activePlayerId;
        },
        activeTeam() {
            const activePlayer = this.gameState.players.find(player =>
                player.id === this.gameState.activePlayerId,
            );
            return this.player?.team?.id === activePlayer?.team?.id;
        },
        player() {
            return this.$store.getters.player;
        },
    },
    methods: {
        getTimeRemaining() {
            const now = moment();
            const lastTurnTime = moment(this.updatedAt);
            const elapsedTimeMs = now.diff(lastTurnTime, 'mins');
            const timeLimitMs = this.timeLimit * 60 * 1000;
            const timeRemainingMs = timeLimitMs - elapsedTimeMs;
            const timeRemainingMins = moment.duration(timeRemainingMs).minutes();
            const timeRemainingSecs = moment.duration(timeRemainingMs).seconds();

            if (timeRemainingMs < 0) {
                return noTimeRemaining;
            }

            if (timeRemainingMs <= 60000 && !this.countdownAlert) {
                this.countdownAlert = true;
            }

            return `${this.padTime(timeRemainingMins)}:${this.padTime(timeRemainingSecs)}`;
        },
        padTime(time) {
            return String(time).length === 1 ? `0${time}` : time;
        },
        startCountdown() {
            const self = this;
            const intervalMs = 1000;

            clearInterval(this.refreshInterval);

            this.refreshInterval = setInterval(() => {
                this.timeRemaining = self.getTimeRemaining();

                if (this.timeRemaining === noTimeRemaining) {
                    clearInterval(this.refreshInterval);
                }
            }, intervalMs);
        },
        openModal() {
            if (this.timedOut && !this.activePlayer) {
                this.$store.dispatch('openModal', { type: 'timeout' });
            }
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .timeout-wrapper {

        .timeout-widget {
            display: flex;
            background: white;
            padding: 8px 10px;
            box-shadow: -1px 1px 1px 1px $medium-gray;
            border-radius: 4px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            transition: width .2s;
            width: 21px;
            overflow: hidden;

            > * {
                align-self: center;
            }

            &.timed-out {
                width: auto;
                overflow: visible;

                &.clickable {
                    cursor: pointer;
                }

                &:hover {
                    width: auto;
                }

                .time-remaining {
                    color: $lancer;
                }
            }

            &.alert {
                width: auto;
                overflow: visible;

                .time-remaining {
                    color: $lancer;
                }
            }

            .time-remaining {
                display: inline-block;
                vertical-align: middle;
                font-family: 'RobotoSlab', 'Avenir', Helvetica, Arial, sans-serif;
                color: $gray;
                margin-left: 10px;
            }

            .claim-victory {
                margin-left: 10px;
            }

            .timeout-icon {
                color: $sage-brown;
                font-size: 1.75em;
                display: inline-block;
                vertical-align: middle;
            }

            &:hover {
                width: 70.76px;
            }

        }

		.waiting-text {
			font-size: .85rem;
			background: white;
			padding: 4px 8px;
			max-width: 75px;
			margin-bottom: 10px;
			border-radius: 4px;
			box-shadow: -1px 1px 1px 1px #b5b5b5;
		}
    }

    @media only screen and (min-width: $screen-sm) {

    }
</style>
